// pages/ContactsAndCompanyInfoEditing/components/CountryCodeSelector/countryCodes.js
export const countryCodes = [
  { code: '+33', flag: '🇫🇷', name: 'France' },
  { code: '+32', flag: '🇧🇪', name: 'Belgium' },
  { code: '+34', flag: '🇪🇸', name: 'Spain' },
  { code: '+1', flag: '🇺🇸', name: 'United States' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+49', flag: '🇩🇪', name: 'Germany' },
  { code: '+39', flag: '🇮🇹', name: 'Italy' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: '+46', flag: '🇸🇪', name: 'Sweden' },
  { code: '+47', flag: '🇳🇴', name: 'Norway' },
  { code: '+45', flag: '🇩🇰', name: 'Denmark' },
  { code: '+358', flag: '🇫🇮', name: 'Finland' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland' },
  { code: '+43', flag: '🇦🇹', name: 'Austria' },
  { code: '+30', flag: '🇬🇷', name: 'Greece' },
  { code: '+48', flag: '🇵🇱', name: 'Poland' },
  { code: '+36', flag: '🇭🇺', name: 'Hungary' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic' },
  { code: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: '+86', flag: '🇨🇳', name: 'China' },
  { code: '+81', flag: '🇯🇵', name: 'Japan' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea' },
  { code: '+91', flag: '🇮🇳', name: 'India' },
  { code: '+55', flag: '🇧🇷', name: 'Brazil' },
  { code: '+52', flag: '🇲🇽', name: 'Mexico' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina' },
  { code: '+61', flag: '🇦🇺', name: 'Australia' },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand' },
  { code: '+27', flag: '🇿🇦', name: 'South Africa' },
  { code: '+20', flag: '🇪🇬', name: 'Egypt' },
  { code: '+90', flag: '🇹🇷', name: 'Turkey' },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+63', flag: '🇵🇭', name: 'Philippines' },
  { code: '+66', flag: '🇹🇭', name: 'Thailand' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia' },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+98', flag: '🇮🇷', name: 'Iran' },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar' },
  { code: '+968', flag: '🇴🇲', name: 'Oman' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait' },
  { code: '+212', flag: '🇲🇦', name: 'Morocco' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus' },
  { code: '+40', flag: '🇷🇴', name: 'Romania' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia' },
  { code: '+385', flag: '🇭🇷', name: 'Croatia' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia' },
  { code: '+350', flag: '🇬🇮', name: 'Gibraltar' },
  { code: '+352', flag: '🇱🇺', name: 'Luxembourg' },
  { code: '+356', flag: '🇲🇹', name: 'Malta' },
  { code: '+357', flag: '🇨🇾', name: 'Cyprus' },
  { code: '+298', flag: '🇫🇴', name: 'Faroe Islands' },
  { code: '+354', flag: '🇮🇸', name: 'Iceland' },
  { code: '+299', flag: '🇬🇱', name: 'Greenland' },
  { code: '+687', flag: '🇳🇨', name: 'New Caledonia' },
  { code: '+689', flag: '🇵🇫', name: 'French Polynesia' },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh' },
  { code: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar' },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia' },
  { code: '+507', flag: '🇵🇦', name: 'Panama' },
  { code: '+56', flag: '🇨🇱', name: 'Chile' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia' },
  { code: '+51', flag: '🇵🇪', name: 'Peru' },
  { code: '+58', flag: '🇻🇪', name: 'Venezuela' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay' },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua' },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala' },
  { code: '+972', flag: '🇮🇱', name: 'Israel' },
  { code: '+963', flag: '🇸🇾', name: 'Syria' },
  { code: '+964', flag: '🇮🇶', name: 'Iraq' },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon' },
  { code: '+962', flag: '🇯🇴', name: 'Jordan' },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
  { code: '+995', flag: '🇬🇪', name: 'Georgia' },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan' },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji' },
  { code: '+682', flag: '🇨🇰', name: 'Cook Islands' },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea' },
  { code: '+685', flag: '🇼🇸', name: 'Samoa' },
  { code: '+683', flag: '🇳🇺', name: 'Niue' },
  { code: '+676', flag: '🇹🇴', name: 'Tonga' },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu' },
  { code: '+231', flag: '🇱🇷', name: 'Liberia' },
  { code: '+221', flag: '🇸🇳', name: 'Senegal' },
  { code: '+220', flag: '🇬🇲', name: 'Gambia' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: '+225', flag: '🇨🇮', name: "Côte d'Ivoire" },
  { code: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: '+229', flag: '🇧🇯', name: 'Benin' },
  { code: '+237', flag: '🇨🇲', name: 'Cameroon' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: '+242', flag: '🇨🇬', name: 'Congo' },
  { code: '+376', flag: '🇦🇩', name: 'Andorra' },
  { code: '+377', flag: '🇲🇨', name: 'Monaco' },
  { code: '+378', flag: '🇸🇲', name: 'San Marino' },
  { code: '+379', flag: '🇻🇦', name: 'Vatican City' },
  { code: '+423', flag: '🇱🇮', name: 'Liechtenstein' },
  { code: '+383', flag: '🇽🇰', name: 'Kosovo' },
  { code: '+382', flag: '🇲🇪', name: 'Montenegro' },
  { code: '+389', flag: '🇲🇰', name: 'North Macedonia' },
  { code: '+374', flag: '🇦🇲', name: 'Armenia' },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia' },
  { code: '+850', flag: '🇰🇵', name: 'North Korea' },
  { code: '+670', flag: '🇹🇱', name: 'Timor-Leste' },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan' },
  { code: '+960', flag: '🇲🇻', name: 'Maldives' },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan' },
  { code: '+970', flag: '🇵🇸', name: 'Palestine' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei' },
  { code: '+1-242', flag: '🇧🇸', name: 'Bahamas' },
  { code: '+1-246', flag: '🇧🇧', name: 'Barbados' },
  { code: '+1-264', flag: '🇦🇮', name: 'Anguilla' },
  { code: '+1-268', flag: '🇦🇬', name: 'Antigua and Barbuda' },
  { code: '+1-784', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
  { code: '+1-758', flag: '🇱🇨', name: 'Saint Lucia' },
  { code: '+1-869', flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
  { code: '+1-868', flag: '🇹🇹', name: 'Trinidad and Tobago' },
  { code: '+1-876', flag: '🇯🇲', name: 'Jamaica' },
  { code: '+1-809', flag: '🇩🇴', name: 'Dominican Republic' },
  { code: '+53', flag: '🇨🇺', name: 'Cuba' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti' },
  { code: '+590', flag: '🇬🇵', name: 'Guadeloupe' },
  { code: '+596', flag: '🇲🇶', name: 'Martinique' }
];